import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { TextAreaInputWUT } from "../../inputs/text-area-input-wut/text-area-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
const TextAreaFieldWUT = ({
  id,
  target,
  label,
  hideLabel,
  placeholder,
  required,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  hasError = false,
  errorMessage,
  disabled = false,
  readOnly,
  description,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        TextAreaInputWUT,
        {
          label,
          placeholder,
          required,
          value,
          onChange,
          onFocus,
          onBlur,
          disabled,
          readOnly,
          inputId,
          hasError,
          ariaDescribedBy,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  TextAreaFieldWUT
};
//# sourceMappingURL=text-area-field-wut.js.map
